import React, { useState, useEffect } from 'react';
import { Modal, Button, FormControl } from 'react-bootstrap';

import { useStateValue } from '../context/state.jsx';
import { closePrompt } from '../context/alert.js';

const Prompt = () => {
	const [{ prompt }, dispatch] = useStateValue();

	const {
		promptText,
		action,
		initialValue = '',
		placeholder
	} = prompt || {};

	const [promptInputText, setPromptInputText] = useState(initialValue || '');

	useEffect(() => {
		if (prompt) {
			setPromptInputText(initialValue || '');
		}
	}, [prompt, initialValue]);

	if (!prompt) {
		return null;
	}

	const submit = () => {
		const value = promptInputText;
		setPromptInputText('');
		dispatch(closePrompt());
		// Defer so this prompt unmounts before nested alert/share work runs.
		window.setTimeout(() => {
			if (typeof action === 'function') {
				action(value);
			}
		}, 0);
	};

	return (
		<Modal
			show
			dialogClassName="swa-dialog prompt-modal"
			backdropClassName="swa-overlay-backdrop"
			className="swa-overlay-modal"
			onHide={() => {
				setPromptInputText('');
				dispatch(closePrompt());
			}}
			centered>
			<Modal.Body>
				<p>{promptText}</p>
				<FormControl
					type="text"
					value={promptInputText}
					autoFocus
					placeholder={placeholder}
					onChange={e => { setPromptInputText(e.target.value); }}
					onKeyDown={e => {
						if (e.key === 'Enter') {
							e.preventDefault();
							submit();
						}
					}} />
			</Modal.Body>
			<Modal.Footer>
				<Button onClick={submit}>OK</Button>
				<Button onClick={() => {
					setPromptInputText('');
					dispatch(closePrompt());
				}}>Cancel</Button>
			</Modal.Footer>
		</Modal>
	);
};

export default Prompt;
